import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=d1ef653e"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"
import style0 from "./footer.vue?vue&type=style&index=0&id=d1ef653e&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FooterSubscription: require('/app/components/footerSubscription.vue').default,Img: require('/app/components/img.vue').default,Footer: require('/app/components/footer.vue').default})
